export default __webpack_public_path__ + "static/media/sec_mantenimiento.8eaf1d2f.png";